<template>
  <div class="page_all">
    <div class="return_link">
      <router-link to="/linkList">＞ 外部リンク</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div v-if="changeFlg" class="title">外部リンクの編集</div>
        <div v-else class="title">外部リンクの追加</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button :disabled="$v.linkTitle.$invalid || $v.linkUrl.$invalid || this.updating" v-if="changeFlg" class="btn_general" v-on:click="linkUpdate()">更新</button>
        <button :disabled="$v.linkTitle.$invalid || $v.linkUrl.$invalid || this.updating" v-else class="btn_general" v-on:click="linkAdd()">追加</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_group">登録内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content_top">
              <div class="index_name">グループ</div>
              <div class="select_group">
                <div>
                  <select class="pull_group" v-model="groupName">
                    <option v-for="group in groups" v-bind:key="group.group_name" v-bind:value="group.group_name">
                      {{ group.group_name }}
                    </option>
                  </select>
                </div>
                <div>
                  <button class="btn_group_plus" @click="openModal">＋</button>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div class="index_name">タイトル</div>
              <div>
                <input v-model.trim="$v.linkTitle.$model" type="text" class="title_text"/>
              </div>
              <div class="message">
                <div v-if="$v.linkTitle.$dirty">
                  <div class="error" v-if="!$v.linkTitle.required">タイトルは必須入力です。</div>
                  <div class="error" v-if="!$v.linkTitle.maxLength">タイトルは{{ $v.linkTitle.$params.maxLength.max }}文字以内で入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_bottom">
              <div class="index_name">URL</div>
              <div>
                <input v-model.trim="$v.linkUrl.$model" type="text" class="url_text"/>
              </div>
              <div class="message">
                <div v-if="$v.linkUrl.$dirty">
                  <div class="error" v-if="!$v.linkUrl.required">URLは必須入力です。</div>
                  <div class="error" v-if="!$v.linkUrl.maxLength">URLは{{ $v.linkUrl.$params.maxLength.max }}文字以内で入力してください。</div>
                  <div class="error" v-if="!$v.linkUrl.url">URLを入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 以下モーダルウィンドウ -->
      <modal v-if="showModal" @close="closeModal">
        <div class="modal_main">
          <table class="tbl_modal">
            <thead>
              <tr>
                <th class="th_modal">
                  <div class="th_modal_group">
                    <div>
                      <span>グループを追加します</span>
                    </div>
                    <div>
                      <button class="btn_general" @click="closeModal">閉じる</button>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="td_modal">
                  <div class="td_modal_group">
                    <div>
                      <input v-model.trim="$v.addGroupName.$model" type="text" class="modal_group_input"/>
                      <div class="message">
                        <div v-if="$v.addGroupName.$dirty">
                          <div class="error" v-if="!$v.addGroupName.required">グループ名は必須入力です。</div>
                          <div class="error" v-if="!$v.addGroupName.maxLength">グループ名は{{ $v.addGroupName.$params.maxLength.max }}文字以内で入力してください。</div>
                        </div>
                      </div>
                    </div>
                    <div class="btn_add">
                      <button :disabled="$v.addGroupName.$invalid" class="btn_general" @click="groupAdd">追加する</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ -->
    </div>
  </div>
</template>

<script>
import modal from '@/components/LinkGroupModal'
import { required, maxLength, url } from 'vuelidate/lib/validators'

export default {
  components: {
    modal
  },
  data: function() {
    return {
      groups: null,
      groupName: "",
      linkTitle: "",
      linkUrl: "",
      // 以下モーダル変数
      showModal: false,
      addGroupName: "",
      dicGroup: {},
      // 変更フラグ
      changeFlg: false,
      // メッセージ
      message: "",
      updating: false,
    }
  },
	mounted() {
    console.log(this.$store.getters.getStateLinkLanguage)
    // 変更フラグ
    this.changeFlg = this.$store.getters.getStateChangeFlg
    // グループ情報を取得
    this.groups = this.$store.getters.getStateGroups
    // 変更の場合はStoreから設定
    if (this.changeFlg) {
      this.link_id = this.$store.getters.getStateLinkId
      this.linkDetail()
    }
  },
  methods: {
    async linkDetail() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'link/detail', {
          params: {
            link_id: this.$store.getters.getStateLinkId
          }
        })
        this.groupName = response.data[0].group_name
        this.linkTitle = response.data[0].link_title
        this.linkUrl = response.data[0].link_url
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async linkAdd() {
      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'link/add', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          group_name: this.groupName,
          link_title: this.linkTitle,
          link_url: this.linkUrl,
          charge_id: this.$store.getters.getStateChargeId,
          language_kind: this.$store.getters.getStateLinkLanguage
        })
        this.$router.push('/linkList')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    async linkUpdate() {
      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'link/update', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          group_name: this.groupName,
          link_id: this.$store.getters.getStateLinkId,
          link_title: this.linkTitle,
          link_url: this.linkUrl,
          charge_id: this.$store.getters.getStateChargeId,
          language_kind: this.$store.getters.getStateLinkLanguage
        })
        this.$router.push('/linkList')
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.updating = false;
    },
    groupAdd: function() {
      // 辞書の作成
      this.$set(this.dicGroup, 'group_name', this.addGroupName)
      this.$store.commit('addStateGroups', this.dicGroup)
      this.groups = this.$store.getters.getStateGroups
      // 初期化
      this.dicGroup = []
      this.addGroupName = ""
      this.closeModal()
    },
		openModal: function() {
			this.showModal = true
		},
		closeModal: function() {
      // validationsモデルオブジェクトをリセット
      this.$v.addGroupName.$reset()

      this.addGroupName = ""
			this.showModal = false
    }
  },
  validations: {
    linkTitle: {
      required,
      maxLength: maxLength(50)
    },
    linkUrl: {
      required,
      maxLength: maxLength(2048),
      url
    },
    addGroupName: {
      required,
      maxLength: maxLength(30)
    }
  }
}
</script>

<style scoped>
table th.th_group {
  text-align: left;
  padding-left: 10px;
}
table tr {
  border: none;
}
table td.td_content_top {
  text-align: left;
  border: none;
  padding: 20px 0px 20px 20px;
}
table td.td_content_middle {
  text-align: left;
  border: none;
  padding: 0px 0px 0px 20px;
}
table td.td_content_bottom {
  text-align: left;
  border: none;
  padding: 0px 0px 0px 20px;
}
.index_name {
  padding: 0px 0px 5px 0px;
}
.btn_group_plus {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  font-size: 18px;
  font-weight: bold;
  padding-right: 23px;
}

.select_group {
  display: flex;
  justify-content: space-between;
}
.pull_group {
  width: 715px;
  height: 25px;
}
.title_text, .url_text {
  width: 715px;
}

/* モーダル画面 */
.modal_main {
  width: 380px;
}
.modal_group_input {
  width: 250px;
}
table.tbl_modal {
  width: 100%;
  border: 1px #666666 solid;
  border-collapse: collapse;
  margin: 0 auto;
}
table th.th_modal {
  font-weight: normal;
  text-align: left;
  padding: 3px 5px 3px 10px;
}
table td.td_modal {
  border: 1px #666666 solid;
  padding: 20px 5px 0px 20px;
}
.th_modal_group, .td_modal_group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn_add {
  padding: 0px 0px 20px 0px;
}
</style>